import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import DashboardShell from "@/components/DashboardShell";
import { AptitudeReportView } from "@/components/aptitude/AptitudeReportView";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Link2, Users, LayoutDashboard, PlayCircle, Mail, FileBadge, Loader2 } from "lucide-react";

const LINKS = [
  { to: "/me", label: "Dashboard", icon: LayoutDashboard, testId: "nav-me-dashboard" },
  { to: "/me/students", label: "My Students", icon: Users, testId: "nav-me-students" },
  { to: "/me/link", label: "My Link", icon: Link2, testId: "nav-me-link" },
  { to: "/me/inbox", label: "Inbox", icon: Mail, testId: "nav-me-inbox" },
  { to: "/me/sample-report", label: "Sample Report", icon: FileBadge, testId: "nav-me-sample-report" },
  { to: "/me/demo", label: "Launch Demo", icon: PlayCircle, testId: "nav-me-demo" },
];

export default function MarketingAptitudeReport() {
  const { studentId } = useParams();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/marketing/students/${studentId}/aptitude-report`).then((res) => setReport(res.data)).catch((e) => {
      setError(e?.response?.data?.detail || "Aptitude Test report not available yet");
    }).finally(() => setLoading(false));
  }, [studentId]);

  return (
    <DashboardShell links={LINKS} activePath="/me/students">
      <Button variant="ghost" data-testid="me-aptitude-back-button" onClick={() => navigate("/me/students")} className="text-slate-500 mb-6">
        <ArrowLeft className="h-4 w-4 mr-2" /> Back to My Students
      </Button>
      {loading && <Loader2 className="h-5 w-5 animate-spin text-indigo-500" />}
      {!loading && error && <p className="text-slate-400" data-testid="me-aptitude-report-error">{error}</p>}
      {report && <AptitudeReportView report={report} />}
    </DashboardShell>
  );
}
